import { config, library } from '@fortawesome/fontawesome-svg-core'

/**
 * Brand Icons.
 */
import {
  faCcMastercard,
  faCcVisa,
  faFacebook,
  faInstagram,
  faLinkedin,
  faMarkdown,
  faTiktok,
  faTwitter,
  faWhatsapp,
  faYoutube
} from '@fortawesome/free-brands-svg-icons'

/**
 * Duo tone Icons.
 */
import { faSpinnerThird } from '@fortawesome/pro-duotone-svg-icons'

/**
 * Light Icons.
 */
import { faRobot as faRobotLight, faSidebar } from '@fortawesome/pro-light-svg-icons'

/**
 * Regular Icons.
 */
import {
  faArrowsRotate,
  faArrowUpRightFromSquare,
  faBan,
  faBars,
  faBuilding,
  faBullhorn,
  faBullseye,
  faBullseyeArrow,
  faCalendar,
  faCertificate,
  faCheck,
  faCircleInfo,
  faCloudArrowDown,
  faCompress,
  faCookieBite,
  faCopy,
  faCreditCard,
  faEllipsisVertical,
  faEnvelope,
  faExpandWide,
  faEye,
  faFlag,
  faFlagPennant,
  faGlobe,
  faHandPointRight,
  faHeart,
  faHouse,
  faIdCard,
  faImage,
  faLaptopMobile,
  faLightbulbOn,
  faLink,
  faLocationPin,
  faLongArrowRight,
  faMessage,
  faMessageCaptions,
  faMessageSmile,
  faNewspaper,
  faPalette,
  faPencil,
  faPlus,
  faQrcode,
  faRectangle,
  faRectangleVertical,
  faRectangleVerticalHistory,
  faRefresh,
  faRobot,
  faShareNodes,
  faShip,
  faSparkles,
  faSquare,
  faTimer,
  faUser,
  faUserCircle,
  faWindowMaximize
} from '@fortawesome/pro-regular-svg-icons'

/**
 * Solid Icons.
 */
import {
  faArrowRightFromBracket,
  faBackwardFast,
  faBookOpen,
  faChartSimple,
  faCheck as faCheckSolid,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCircle,
  faCode,
  faCopy as faCopySolid,
  faCrown,
  faEnvelope as faEnvelopeSolid,
  faExclamation,
  faEye as faEyeSolid,
  faFileAlt,
  faFileImage,
  faFileLines,
  faFilePdf,
  faFilePlus,
  faFilm,
  faGem,
  faGift,
  faHouse as faHouseSolid,
  faImageLandscape,
  faLink as faLinkSolid,
  faLock,
  faLongArrowLeft,
  faLongArrowRight as faLongArrowRightSolid,
  faMapMarker,
  faObjectsColumn,
  faPalette as faPaletteSolid,
  faPencil as faPencilSolid,
  faPhone,
  faPhotoVideo,
  faPlayCircle,
  faQrcode as faQrcodeSolid,
  faQuestion,
  faQuoteLeft,
  faRetweet as faRetweetSolid,
  faSearch,
  faShare,
  faStars,
  faTimes,
  faUserCircle as faUserCircleSolid,
  faWaveform
} from '@fortawesome/pro-solid-svg-icons'

config.autoAddCss = false

library.add(
  faCcMastercard,
  faCcVisa,
  faFacebook,
  faInstagram,
  faLinkedin,
  faMarkdown,
  faTiktok,
  faTwitter,
  faWhatsapp,
  faYoutube
)

library.add(faSpinnerThird)

library.add(faRobotLight, faSidebar)

library.add(
  faArrowsRotate,
  faArrowUpRightFromSquare,
  faBan,
  faBars,
  faBuilding,
  faBullhorn,
  faBullseye,
  faBullseyeArrow,
  faCalendar,
  faCertificate,
  faCheck,
  faCircleInfo,
  faCloudArrowDown,
  faCompress,
  faCookieBite,
  faCopy,
  faCreditCard,
  faEllipsisVertical,
  faEnvelope,
  faExpandWide,
  faEye,
  faFlag,
  faFlagPennant,
  faGlobe,
  faHandPointRight,
  faHeart,
  faHouse,
  faIdCard,
  faImage,
  faLaptopMobile,
  faLightbulbOn,
  faLink,
  faLocationPin,
  faLongArrowRight,
  faMessage,
  faMessageCaptions,
  faMessageSmile,
  faNewspaper,
  faPalette,
  faPencil,
  faPlus,
  faQrcode,
  faRectangle,
  faRectangleVertical,
  faRectangleVerticalHistory,
  faRefresh,
  faRobot,
  faShareNodes,
  faShip,
  faSparkles,
  faSquare,
  faTimer,
  faUser,
  faUserCircle,
  faWindowMaximize
)

library.add(
  faArrowRightFromBracket,
  faBackwardFast,
  faBookOpen,
  faChartSimple,
  faCheckSolid,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCircle,
  faCode,
  faCopySolid,
  faCrown,
  faEnvelopeSolid,
  faExclamation,
  faEyeSolid,
  faFileAlt,
  faFileImage,
  faFileLines,
  faFilePdf,
  faFilePlus,
  faFilm,
  faGem,
  faGift,
  faHouseSolid,
  faImageLandscape,
  faLinkSolid,
  faLock,
  faLongArrowLeft,
  faLongArrowRightSolid,
  faMapMarker,
  faObjectsColumn,
  faPaletteSolid,
  faPencilSolid,
  faPlayCircle,
  faPhone,
  faPhotoVideo,
  faQrcodeSolid,
  faQuestion,
  faQuoteLeft,
  faRetweetSolid,
  faSearch,
  faShare,
  faStars,
  faTimes,
  faUserCircleSolid,
  faWaveform
)

export default defineNuxtPlugin(() => {
  //
})
